export const BG_POPUP_ACTIVATE_BOOK =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/bg-popup-activate-book-01-01.png`;
export const BG_POPUP_SUCCESS =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/bg-popup-success-2-01.png`;
export const LOGO_MONKEY =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/logo_hoc_10.png`;
export const LOGO_VEPIC =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/logo-pevic.png`;

export const IMAGE_UPDATE_INFORMATION =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/image-update-information.png`;

export const BACKGROUND_BANNER_HOME =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/banner-home-page-1-03-01.png`;
export const BACKGROUND_BANNER_HOME_1 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/banner-home-page-2-01.png`;
export const BACKGROUND_HOME_1 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/bg-home-1-01.png`;
export const BACKGROUND_BANNER_RELEASE =
  `${process.env.REACT_APP_MEDIA_URL_APP}E_Learning/thumb/banner-home-page-1.png`;
export const IMAGE_BANNER_HOME =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/images-banner-home-1.png`;
export const IMAGE_BANNER_SLIDE =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/banner3-02-02.png`;
export const IMAGE_BANNER_HOME_1 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/img-banner-home-2-03-02.png`;
export const IMAGE_BANNER_EDUCATION =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/banner-education-page-01.png`;
export const IMAGE_BANNER_EDUCATION_2 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/img-banner-education-01.png`;
export const BG_BANNER_TUTORIAL =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/banner-tutorial.page-01.png`;
export const BG_BANNER_INTRODUCE =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/banner-introduce-page-02.png`;
export const IMAGE_BANNER_INTRODUCE_1 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/img-banner-introduce-1-01.png`;
export const BG_BANNER_BOOKS_PAGE =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/banner-book-page-01.png`;
export const IMAGE_BANNER_BOOKS_PAGE =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/img-banner-books-page-01.png`;
export const IMAGE_BOX_HOME_1 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/box-home-1-01.png`;
export const IMAGE_BOX_HOME_2 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/box-home-6-02.png`;
export const IMAGE_BOX_HOME_3 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/box-home-6.png`;
export const IMAGE_BOX_HOME_4 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/box-home-4-01.png`;
export const IMAGE_BOX_HOME_5 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/img-selection-home-2-01.png`;
export const IMAGE_BOX_HOME_6 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/img-selection-home-3-02.png`;
export const IMAGE_BOX_HOME_7 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/img-selection-home-1-01.png`;
export const IMAGE_BOX_HOME_8 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/img-selection-home-01-01.png`;

export const IMAGE_BG_SECTION_HOME_1 =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/bg-section-home-1-01-01.png`;
export const IMAGE_ERROR_BOOK =
  `${process.env.REACT_APP_MEDIA_URL_APP}upload/web/background-web/error-book-01.png`;
